module.exports = __webpack_public_path__ + "img/jcb.ab1fb383.svg";